import React, { Component, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './ocorrenciaForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';

import { 
	setModoTela, setFiltroAnalise as setFiltro, initForm, salvar, excluir, getListaGestaoAnalise as getLista,
	getListaTipo, getListaMotorista, salvarAbona, getListaStatusGestao, getListaUsuario
} from './ocorrenciaActions';
import Aguardando from '../common/template/aguardando';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import Select from '../common/form/select';

class OcorrenciaAnalise extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: '',
		ordenacaoPrincipal: {
			nome_motorista: 1
		},
		ordenacao: {
		}
	}

    componentWillMount() {
		this.props.setModoTela('lista');
		
        this.props.getLista();
		this.props.getListaTipo();
		this.props.getListaMotorista();
		this.props.getListaStatusGestao();
		this.props.getListaUsuario();
    }

	getNovaOrdenacaoPrincipal(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	getIconeOrdenacaoPrincipal(tipo) {
		if (tipo == 1) {
			return <i class="fas fa-sort-amount-down-alt" />;
		} else if (tipo == 2) {
			return <i class="fas fa-sort-amount-up" />;
		} else {
			return null;
		}
	}

	getNovaOrdenacao(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	getIconeOrdenacao(tipo) {
		if (tipo == 1) {
			return <i class="fas fa-sort-amount-down-alt" />;
		} else if (tipo == 2) {
			return <i class="fas fa-sort-amount-up" />;
		} else {
			return null;
		}
	}

    render() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.props.lista.filter(item => {

			return !(this.props.filtro.pesquisar || '').trim()
				|| (this.props.filtro.pesquisar.toUpperCase() || '').split('+').filter(pesquisar => (pesquisar || '').trim()).filter(pesquisar => {
				if (pesquisar
					&& !(`
					${DateFormat.formatarDataHoraSqlParaTela(item.datahora_ocorrencia)} 
					${item.nome_motorista} 
					${DateFormat.formatarDataSqlParaTela(item.data_admissao_motorista)} 
					${item.nome_tipo} 
					${FormatUtils.formatarValorTela(item.percentual_desconto, 2)}
					${item.nome_responsavel || item.nome_usuario_inclusao}
					${item.nome_status_gestao}
				`).toUpperCase().includes(pesquisar)) {
					return false;
				}

				return true;

			}).length > 0;
			
		}).filter(item => {				

			if (!this.props.usuarioCarregado) {
				return false;
			} else if (this.props.usuarioCarregado.acesso_ocorrencia) {
				return true;
			}
			return false;
		});

		lista.sort((a, b) => this.state.ordenacaoPrincipal.nome_motorista == 1 
			? (a.nome_motorista > b.nome_motorista ? 1 : -1) 
			: (a.nome_motorista > b.nome_motorista ? -1 : 1));

		let idMotorista = 0;
		let listaPrincipal = [];
		lista = lista.map(item => {
			if (item.id_motorista != idMotorista) {
				idMotorista = item.id_motorista;
				listaPrincipal.push({
					...item,
					quantidade_motorista: lista.filter(itemAux => itemAux.id_motorista == item.id_motorista).length
				});
			}

			return {
				...item,
				quantidade_motorista: lista.filter(itemAux => itemAux.id_motorista == item.id_motorista).length
			};
		});

		//Ordenação principal
		if (this.state.ordenacaoPrincipal.nome_motorista) {
			listaPrincipal.sort((a, b) => this.state.ordenacaoPrincipal.nome_motorista == 1 
				? (a.nome_motorista > b.nome_motorista ? 1 : -1) 
				: (a.nome_motorista > b.nome_motorista ? -1 : 1));
		} else if (this.state.ordenacaoPrincipal.data_admissao_motorista) {
			listaPrincipal.sort((a, b) => this.state.ordenacaoPrincipal.data_admissao_motorista == 1 
				? (a.data_admissao_motorista > b.data_admissao_motorista ? 1 : -1) 
				: (a.data_admissao_motorista > b.data_admissao_motorista ? -1 : 1));
		} else if (this.state.ordenacaoPrincipal.quantidade_motorista) {
			listaPrincipal.sort((a, b) => this.state.ordenacaoPrincipal.quantidade_motorista == 1 
				? (a.quantidade_motorista > b.quantidade_motorista ? 1 : -1) 
				: (a.quantidade_motorista > b.quantidade_motorista ? -1 : 1));
		} else {
			listaPrincipal.sort((a, b) => this.state.ordenacaoPrincipal.nome_motorista == 1 
				? (a.nome_motorista > b.nome_motorista ? 1 : -1) 
				: (a.nome_motorista > b.nome_motorista ? -1 : 1));
		}

		//Lista Secundária
		if (this.state.ordenacao.nome_tipo) {
			lista.sort((a, b) => this.state.ordenacao.nome_tipo == 1 
				? (a.nome_tipo > b.nome_tipo ? 1 : -1) 
				: (a.nome_tipo > b.nome_tipo ? -1 : 1));
		} else if (this.state.ordenacao.percentual_desconto) {
			lista.sort((a, b) => this.state.ordenacao.percentual_desconto == 1 
				? (parseFloat(a.percentual_desconto || 0) > parseFloat(b.percentual_desconto || 0) ? 1 : -1) 
				: (parseFloat(a.percentual_desconto || 0) > parseFloat(b.percentual_desconto || 0) ? -1 : 1));
		} else if (this.state.ordenacao.datahora_ocorrencia) {
			lista.sort((a, b) => this.state.ordenacao.datahora_ocorrencia == 1 
				? (a.datahora_ocorrencia > b.datahora_ocorrencia ? 1 : -1) 
				: (a.datahora_ocorrencia > b.datahora_ocorrencia ? -1 : 1));
		} else if (this.state.ordenacao.nome_usuario_inclusao) {
			lista.sort((a, b) => this.state.ordenacao.nome_usuario_inclusao == 1 
				? ((a.nome_responsavel || a.nome_usuario_inclusao) > (b.nome_responsavel || b.nome_usuario_inclusao) ? 1 : -1) 
				: ((a.nome_responsavel || a.nome_usuario_inclusao) > (b.nome_responsavel || b.nome_usuario_inclusao) ? -1 : 1));
		} else if (this.state.ordenacao.nome_status_gestao) {
			lista.sort((a, b) => this.state.ordenacao.nome_status_gestao == 1 
				? ((a.nome_status_gestao || '') > (b.nome_status_gestao || '') ? 1 : -1) 
				: ((a.nome_status_gestao || '') > (b.nome_status_gestao || '') ? -1 : 1));
		} else {
			lista.sort((a, b) => this.state.ordenacao.nome_tipo == 1 
				? (a.nome_tipo > b.nome_tipo ? 1 : -1) 
				: (a.nome_tipo > b.nome_tipo ? -1 : 1));
		}

		
		//Lista Exportar
		let listaExportar = [];
		listaPrincipal.forEach(item => {
			lista.filter(itemInterno => itemInterno.id_motorista == item.id_motorista).forEach(itemInterno => {
				listaExportar.push({
					...itemInterno,
					datahora_ocorrencia: DateFormat.formatarDataSqlParaTela(itemInterno.datahora_ocorrencia),
					nome_responsavel: itemInterno.nome_responsavel || itemInterno.nome_usuario_inclusao
				});
			})
		});						

		return (
			<Content>
				<Aguardando aguardando={this.props.aguardando} />
				<ContentCard>

					<ContentCardBody>			
						<Row>
							<InputPesquisa
								maxWidth={350}
								minWidth={350}
								cols='12 12 12 12'
								label='Pesquisar'
								value={this.props.filtro.pesquisar}
								onChange={value => this.props.setFiltro({ ...this.props.filtro, pesquisar: value })} />

							<LabelAndInputDate
								label='Período Inicial'
								cols='12 6 4 4'
								value={this.props.filtro.data_inicial}
								onChange={value => {
									this.props.setFiltro({
										...this.props.filtro,
										data_inicial: value
									});
								}} />

							<LabelAndInputDate
								label='Período Final'
								cols='12 6 4 4'
								value={this.props.filtro.data_final}
								onChange={value => {
									this.props.setFiltro({
										...this.props.filtro,
										data_final: value
									});
								}} />

							<Select
								maxWidth={350}
								options={this.props.listaStatusGestao}
								label='Status'
								cols=' 12 4 4 3'
								placeholder='Selecione'
								multiple
								value={this.props.filtro.ids_status}
								onChange={values => {
									this.props.setFiltro({
										...this.props.filtro,
										ids_status: values.map(item => item.value)
									});
								}} />
								
							<Select
								maxWidth={350}
								options={this.props.listaMotorista}
								label='Motorista'
								cols=' 12 4 4 3'
								placeholder='Selecione'
								multiple
								value={this.props.filtro.ids_motorista}
								onChange={values => {
									this.props.setFiltro({
										...this.props.filtro,
										ids_motorista: values.map(item => item.value)
									});
								}} />
						
						<Select
							maxWidth={200}
							options={this.props.listaTipoOcorrrencia}
							label='Tipo'
							cols=' 12 4 4 3'
							placeholder='Selecione'
							multiple
							value={this.props.filtro.ids_tipo_ocorrencia}
							onChange={values => {
								this.props.setFiltro({
									...this.props.filtro,
									ids_tipo_ocorrencia: values.map(item => item.value)
								});
							}} />
							
							<Select
								maxWidth={350}
								options={this.props.listaTipo}
								label='Ocorrência'
								cols=' 12 4 4 3'
								placeholder='Selecione'
								multiple
								value={this.props.filtro.ids_tipo}
								onChange={values => {
									this.props.setFiltro({
										...this.props.filtro,
										ids_tipo: values.map(item => item.value)
									});
								}} />

							<Select
								maxWidth={350}
								options={this.props.listaUsuario}
								label='Responsável'
								cols=' 12 4 4 3'
								placeholder='Selecione'
								multiple
								value={this.props.filtro.ids_usuario_analise}
								onChange={values => {
									this.props.setFiltro({
										...this.props.filtro,
										ids_usuario_analise: values.map(item => item.value)
									});
								}} />

							<div style={{ width: 160, marginTop: 8, marginLeft: 8 }}>

								<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
									onClick={() => {
										this.props.getLista(this.state.filtro);
									}}>
									<i class='fas fa-sync-alt'></i> Atualizar
								</a>

								<ExcelFile
									filename={'Ocorrências - Análise'}
									element={
										<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}>
											<i class='fas fa-file-excel'></i> Exportar
										</a>
									}>
									<ExcelSheet data={listaExportar.map(item => ({
										...item,
										data_admissao_motorista: DateFormat.formatarDataSqlParaTela(item.data_admissao_motorista)
									}))} name='Ocorrências - Análise'>
										<ExcelColumn label='Motorista' value='nome_motorista' />
										<ExcelColumn label='Data Admissão' value='data_admissao_motorista' />
										<ExcelColumn label='Qtd.' value='quantidade_motorista' type='number' />
										<ExcelColumn label='Ocorrência' value='nome_tipo' />
										<ExcelColumn label='Perc. Desconto' value='percentual_desconto' type='number' />
										<ExcelColumn label='Data' value='datahora_ocorrencia' />
										<ExcelColumn label='Responsável' value='nome_responsavel' />
										<ExcelColumn label='Status' value='nome_status_gestao' />
									</ExcelSheet>												
								</ExcelFile>
							</div>
						</Row>	
					
						<div 
							style={{ 
								backgroundColor: '#1F3066',
								marginLeft: -8,
								marginRight: -8,
								marginBottom: -8,
								paddingTop: 1,
								paddingLeft: 8,
								paddingRight: 8,
								paddingBottom: 8,
								height: window.innerWidth < 768 ? '100%' : (
									window.innerWidth < 1093 ? `${window.innerHeight - 340}px`
									: (
										window.innerWidth < 1799 
										? `${window.innerHeight - 260}px`
										: (
											window.innerWidth < 4000 
											? `${window.innerHeight - 260}px`
											: `${window.innerHeight - 190}px`
										)
									)
								)
							}}>
							<Table responsive border striped alturaFixa 
									maxHeight={window.innerWidth < 768 ? '100%' : window.innerWidth < 768 ? '100%' : (
										window.innerWidth < 1093 ? `${window.innerHeight - 340}px`
										: (
											window.innerWidth < 1799 
											? `${window.innerHeight - 260}px`
											: (
												window.innerWidth < 4000 
												? `${window.innerHeight - 260}px`
												: `${window.innerHeight - 190}px`
											)
										)
									)}>
								<THead>
									<Tr backgroundColor={'#1F3066'}
										color={'#ffffff'}
										height={47}>
										<Th paddingTop={2} paddingBottom={2} 
											onClick={() => this.setState({ ...this.state, ordenacaoPrincipal: { nome_motorista: this.getNovaOrdenacaoPrincipal(this.state.ordenacaoPrincipal.nome_motorista) }})} 
											sticky width={150} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Motorista {this.getIconeOrdenacaoPrincipal(this.state.ordenacaoPrincipal.nome_motorista)}</Th>											
										<Th paddingTop={2} paddingBottom={2} 
											onClick={() => this.setState({ ...this.state, ordenacaoPrincipal: { data_admissao_motorista: this.getNovaOrdenacaoPrincipal(this.state.ordenacaoPrincipal.data_admissao_motorista) }})} 
											sticky width={40} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Admissão {this.getIconeOrdenacaoPrincipal(this.state.ordenacaoPrincipal.data_admissao_motorista)}</Th>
										<Th paddingTop={2} paddingBottom={2} 
											onClick={() => this.setState({ ...this.state, ordenacaoPrincipal: { quantidade_motorista: this.getNovaOrdenacaoPrincipal(this.state.ordenacaoPrincipal.quantidade_motorista) }})} 
											sticky width={20} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Qtd. {this.getIconeOrdenacaoPrincipal(this.state.ordenacaoPrincipal.quantidade_motorista)}</Th>
										<Th paddingTop={2} paddingBottom={2} 
											onClick={() => this.setState({ ...this.state, ordenacao: { nome_tipo: this.getNovaOrdenacao(this.state.ordenacao.nome_tipo) }})} 
											sticky width={300} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Ocorrência {this.getIconeOrdenacao(this.state.ordenacao.nome_tipo)}</Th>
										<Th paddingTop={2} paddingBottom={2} 
											onClick={() => this.setState({ ...this.state, ordenacao: { percentual_desconto: this.getNovaOrdenacao(this.state.ordenacao.percentual_desconto) }})} 
											sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter title='Percentual de Desconto'>% Desc. {this.getIconeOrdenacao(this.state.ordenacao.percentual_desconto)}</Th>
										<Th paddingTop={2} paddingBottom={2} 
											onClick={() => this.setState({ ...this.state, ordenacao: { datahora_ocorrencia: this.getNovaOrdenacao(this.state.ordenacao.datahora_ocorrencia) }})} 
											sticky width={50} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Data {this.getIconeOrdenacao(this.state.ordenacao.datahora_ocorrencia)}</Th>									
										<Th paddingTop={2} paddingBottom={2} 
											onClick={() => this.setState({ ...this.state, ordenacao: { nome_usuario_inclusao: this.getNovaOrdenacao(this.state.ordenacao.nome_usuario_inclusao) }})} 
											sticky width={150} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Responsável {this.getIconeOrdenacao(this.state.ordenacao.nome_usuario_inclusao)}</Th>
										<Th paddingTop={2} paddingBottom={2} 
											onClick={() => this.setState({ ...this.state, ordenacao: { nome_status_gestao: this.getNovaOrdenacao(this.state.ordenacao.nome_status_gestao) }})} 
											sticky width={80} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Status {this.getIconeOrdenacao(this.state.ordenacao.nome_status_gestao)}</Th>
										<Th paddingTop={2} paddingBottom={2} 
											sticky width={20} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter title='Ações'></Th>
									</Tr>
								</THead>
								<TBody>
									{listaPrincipal.map((item, i) => (
										<>
											<Tr key={`p-${item.id}`}
												backgroundColor={this.state.linhaSelecionada == `p-${item.id}` ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
												onClick={() => this.setState({ ...this.state, linhaSelecionada: `p-${item.id}` })} >
												<Td  minWidth={150} color={'#000'} alignCenter small >{item.nome_motorista}</Td>
												<Td  minWidth={40} color={'#000'} alignCenter small>{DateFormat.formatarDataSqlParaTela(item.data_admissao_motorista)}</Td>
												<Td  minWidth={20} color={'#000'} alignCenter small>{item.quantidade_motorista}</Td>
												<Td  minWidth={300} color={'#000'} alignCenter small></Td>
												<Td  minWidth={10} color={'#000'} alignCenter small></Td>
												<Td  minWidth={50} color={'#000'} alignCenter small></Td>
												<Td  minWidth={150} color={'#000'} alignCenter small></Td>
												<Td  minWidth={80} color={'#000'} alignCenter small></Td>
												<Td minWidth={20} alignCenter>
													<ButtonTable
														type={'primary'}
														icon={this.props.filtro.idMotoristaSelecionado == item.id_motorista ? 'fas fa-minus' : 'fas fa-plus'}
														visible={true}
														small
														event={() => {
															this.props.setFiltro({
																...this.props.filtro,
																idMotoristaSelecionado: this.props.filtro.idMotoristaSelecionado == item.id_motorista ? null : item.id_motorista
															});
														}} />
												</Td>
											</Tr>
											{(this.props.filtro.idMotoristaSelecionado == item.id_motorista ? lista : [])
											.filter(itemInterno => itemInterno.id_motorista == item.id_motorista
											).map((itemInterno, j) => (
												<Tr key={itemInterno.id}
													backgroundColor={this.state.linhaSelecionada == itemInterno.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
													onClick={() => this.setState({ ...this.state, linhaSelecionada: itemInterno.id })} >
													<Td minWidth={150} color={'#000'} alignCenter small></Td>
													<Td minWidth={40} color={'#000'} alignCenter small></Td>
													<Td minWidth={20} color={'#000'} alignCenter small></Td>
													<Td minWidth={300} color={'#000'} alignCenter small>{itemInterno.nome_tipo}</Td>
													<Td minWidth={10} color={'#000'} alignCenter small>{FormatUtils.formatarValorTela(itemInterno.percentual_desconto, 2)}</Td>
													<Td minWidth={50} color={'#000'} alignCenter small>{DateFormat.formatarDataSqlParaTela(itemInterno.datahora_ocorrencia)}</Td>
													<Td minWidth={150} color={'#000'} alignCenter small>{itemInterno.nome_responsavel || itemInterno.nome_usuario_inclusao}</Td>
													<Td minWidth={80} color={'#000'} alignCenter small>{itemInterno.nome_status_gestao}</Td>
													<Td minWidth={20} alignCenter>
														
													</Td>
												</Tr>
											))}
										</>
									))}
								</TBody>
							</Table>
						</div>
					</ContentCardBody>
				</ContentCard>
			</Content>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.ocorrencia.aguardando,
	modoTela: state.ocorrencia.modoTela,
	lista: state.ocorrencia.listaGestaoAnalise,
	filtro: state.ocorrencia.filtroAnalise,
	listaTipo: state.ocorrencia.listaTipo,
	listaMotorista: state.ocorrencia.listaMotorista,
	listaStatusGestao: state.ocorrencia.listaStatusGestao,
	listaUsuario: state.ocorrencia.listaUsuario,
	listaTipoOcorrrencia: state.ocorrencia.listaTipoOcorrrencia
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, initForm, salvar, excluir, getLista,
	getListaTipo, getListaMotorista, salvarAbona, getListaStatusGestao, getListaUsuario
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(OcorrenciaAnalise);
